<script setup lang="ts">
interface AgentProps {
  id: number;
  first_name: string;
  last_name: string;
}

defineProps<{ agent: AgentProps }>();
</script>
<template>
  <NuxtLink :to="`/agents/${agent.id}`">
    {{ agent.first_name }}
    {{ agent.last_name }}
  </NuxtLink>
</template>
